module.exports = __webpack_public_path__ + "static/active-barre-20224-6d83083c51255b9667b8793a44f51560.jpg";